// @flow
import React, { FC, useEffect } from 'react';
import translate from '../../translate';
import changeFormValue from '../../utils/changeFormValue';
import TextField from '../../components/TextField';

export interface TestEmailProps {
    data: any;
    setData: any;
}
const TestEmail: FC<TestEmailProps> = (props) => {
    useEffect(() => {
        props.setData({ data: {}, errors: {}, disabled: true });
    }, []);

    const { data, errors } = props.data;

    const changeValue: any = (value: any, dataKey: any, error: any) => {
        const newData = changeFormValue(value, dataKey, error, data, errors);
        const newErrors = newData.errors || errors || {};
        props.setData({ data: newData.data, errors: newErrors, disabled: !!Object.keys(newErrors).length });
    };

    if (!data) {
        return null;
    }

    return (
        <div>
            <TextField
                value={data?.email}
                label={translate('emailTemplateDetail.email')}
                onChange={(value: any, error: any): any => changeValue(value, 'email', error)}
                type="email"
                name="email"
                error={errors?.email}
                required
            />
        </div>
    );
};

export default TestEmail;
